import React, {useEffect, useState} from 'react';
import {Link, useParams, withRouter} from 'react-router-dom';
import {Card, CardBody, Col, Container, Row} from 'reactstrap';
import ImportViewCard from './components/ImportView';
import {IMPORT_DATA} from "./components/MockData";
import {connect, useDispatch} from "react-redux";
import axios from "axios";



const ImportView = ({organization}) => {

  const { id } = useParams()
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true) //first page load!
  const [importCsv, setImportCsv] = useState(null)

  const fetchImportCsv = async ( id, organization ) => {
    try {
      const response = await axios.get(`/organization/${organization.id}/import/view/${id}`);
      console.log(response);
      return response.data;
    } catch (e) {
      throw new Error(`API error:${e?.message}`);
    }
  };

  useEffect( ()=>{
    fetchImportCsv( id, organization )
      .then( response => {
        setImportCsv(response);
        setIsLoading(false)
      })
  }, [id, organization])

  const isQa = process.env.REACT_APP_SENTRY_ENVIRONMENT !== 'production';

  const [isRunning, setIsRunning] = useState(false);
  const [runMessage, setRunMessage] = useState(null);

  const runImport = async () => {
    setIsRunning(true);
    setRunMessage(null);
    try {
      await axios.post(`/organization/${organization.id}/import/${id}/run`);
      setRunMessage(null);
      pollImportStatus();
    } catch (e) {
      setRunMessage({ type: 'error', text: 'Failed to start import.' });
      setIsRunning(false);
    }
  };

  const pollImportStatus = () => {
    const interval = setInterval(async () => {
      try {
        const response = await axios.get(`/organization/${organization.id}/import/view/${id}`);
        const data = response.data;
        if (data.is_imported) {
          clearInterval(interval);
          setImportCsv(data);
          setIsRunning(false);
          setRunMessage({ type: 'success', text: 'Import completed successfully.' });
        }
      } catch (e) {
        clearInterval(interval);
        setIsRunning(false);
        setRunMessage({ type: 'error', text: 'Error checking import status.' });
      }
    }, 5000);
  };

  const downloadImportCsv = async ( item ) => {
    try {
      const response = await axios.post(
        `/organization/${organization.id}/import/download/${item.id}`,
        {},
        {
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/octet-stream',
          }
        }
      );
      // Create download link to download csv
      const url = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = item.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (e) {
      throw new Error(`API error:${e?.message}`);
    }
  };


  if (isLoading || !importCsv) {
    return <p>Loading...</p>;
  }
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Imported File</h3>
          <h3 className="page-subhead subhead">
            <Link className="" to="/">Home</Link>
            &nbsp;/ <Link className="" to="/import/list">Files</Link>
            &nbsp;/ {importCsv.name}
          </h3>
        </Col>
      </Row>
      <Row>
        <ImportViewCard
          item={importCsv}
          downloadImportCsv={downloadImportCsv}
          onRunImport={isQa && !importCsv.is_imported ? runImport : null}
          isRunning={isRunning}
          runMessage={runMessage}
        />
      </Row>
    </Container>
  )
}

export default withRouter(connect((state) => ({
  organization: state.organization
}))(ImportView));

